module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_IT-6c21874316c330c80ef125d5052d5e5a.svg";